"use client";

import * as Sentry from "@sentry/nextjs";
import { AlertTriangleIcon } from "lucide-react";
import { useEffect } from "react";

import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";
import { ErrorSurface, reportUserFacingError } from "@/lib/analytics";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.captureException(error);
    reportUserFacingError({
      error,
      surface: ErrorSurface.APP,
      properties: { digest: error.digest },
    });
  }, [error]);

  return (
    <html>
      <body className="h-screen flex flex-col">
        <div className="p-4 md:p-8 flex justify-center items-center flex-1">
          <EmptyState
            icon={<AlertTriangleIcon className="size-12" />}
            title="Something went wrong"
            description="An error occurred while loading the application. We've been notified and will investigate the issue. Please try again later."
            actions={
              <Button variant="outline" asChild>
                <a href="mailto:support@edra.ai">Contact support</a>
              </Button>
            }
          />
        </div>
      </body>
    </html>
  );
}
